document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.collection .switcher-links h4').forEach((heading) => {
    heading.addEventListener('click', () => {
      heading.classList.add('active');

      for (const sibling of heading.parentNode.children) {
        if (sibling !== heading) sibling.classList.remove('active');
      }

      document.querySelector('slideshow-component#' + heading.children[0].id).style.display = 'block';
      if (document.getElementById('description-' + heading.children[0].id)) {
        document.getElementById('description-' + heading.children[0].id).style.display = 'block';
      }

      document.querySelectorAll('slideshow-component').forEach((slideshow) => {
        if (slideshow.id !== heading.children[0].id) {
          slideshow.style.display = 'none';
        }
      });
      document.querySelectorAll('.collection__description').forEach((description) => {
        if (description.id !== 'description-' + heading.children[0].id) {
          description.style.display = 'none';
        }
      });
    });
  });
});
